import {
  getBoardData, getCalculator,
  getCards,
  getGame, getGamesSettings,
  getTableData,
  setPlayersSettings
} from "../helpers/players"

export const initialGame = getGame();

export const initialRules = initialGame.rules;

export const tableData = getTableData(initialRules.numberOfCardsOnBoard);

export const initialBoardData = getBoardData(initialRules.minPlayers, initialRules.numberOfCardsInHand, tableData);

export const initialSettingsPlayers = setPlayersSettings(initialRules.minPlayers, initialRules.maxPlayers);

export const gameSettings = {
  id: getCalculator().id,
  rules: getGamesSettings(),
  players: initialSettingsPlayers,
};

export const ranksAndSuits = {
  ranks: [
    {
      label: '2',
      name: 'two',
      id: 'RANK_TWO',
    },
    {
      label: '3',
      name: 'three',
      id: 'RANK_THREE',
    },
    {
      label: '4',
      name: 'four',
      id: 'RANK_FOUR',
    },
    {
      label: '5',
      name: 'five',
      id: 'RANK_FIVE',
    },
    {
      label: '6',
      name: 'six',
      id: 'RANK_SIX',
    },
    {
      label: '7',
      name: 'seven',
      id: 'RANK_SEVEN',
    },
    {
      label: '8',
      name: 'eight',
      id: 'RANK_EIGHT',
    },
    {
      label: '9',
      name: 'nine',
      id: 'RANK_NINE',
    },
    {
      label: '10',
      name: 'ten',
      id: 'RANK_TEN',
    },
    {
      label: 'J',
      name: 'jack',
      id: 'RANK_JACK',
    },
    {
      label: 'Q',
      name: 'queen',
      id: 'RANK_QUEEN',
    },
    {
      label: 'K',
      name: 'king',
      id: 'RANK_KING',
    },
    {
      label: 'A',
      name: 'ace',
      id: 'RANK_ACE',
    },
  ],
  suits: [
    {
      name: 'club',
      color: 'black',
      id: 'SUIT_CLUB',
    },
    {
      name: 'diamond',
      color: 'red',
      id: 'SUIT_DIAMOND',
    },
    {
      name: 'heart',
      color: 'red',
      id: 'SUIT_HEART',
    },
    {
      name: 'spade',
      color: 'black',
      id: 'SUIT_SPADE',
    }
  ]
};

export const menuCards = getCards(ranksAndSuits);